import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';
import { useLanguage } from '../context/LanguageContext';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [status, setStatus] = useState(null);
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus(null);
    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', { email });

      if (response.data.success) {
        setStatus('success');
        setEmail('');
      }
    } catch (err) {
      const isUserNotFound = err.response?.status === 404 && (
        err.response?.data?.userNotFound ||
        err.response?.data?.error?.includes('Aucun compte')
      );
      if (isUserNotFound) {
        setStatus('notFound');
      } else {
        setError(err.response?.data?.error || t('forgotPassword.errorGeneric'));
      }
    } finally {
      setLoading(false);
    }
  };

  if (status === 'success') {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <h1>{t('forgotPassword.title')}</h1>
          <div className="success-message" style={{
            backgroundColor: '#d4edda',
            color: '#155724',
            padding: '15px',
            borderRadius: '5px',
            marginBottom: '20px',
            border: '1px solid #c3e6cb'
          }}>
            {t('forgotPassword.successBody')}
          </div>
          <p className="auth-link">
            <Link to="/login">{t('forgotPassword.backLogin')}</Link>
          </p>
        </div>
      </div>
    );
  }

  if (status === 'notFound') {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <h1>{t('forgotPassword.title')}</h1>
          <div style={{
            backgroundColor: '#fff3cd',
            color: '#856404',
            padding: '15px',
            borderRadius: '5px',
            marginBottom: '20px',
            border: '1px solid #ffeaa7',
            textAlign: 'center'
          }}>
            <p style={{ margin: '0 0 15px 0', fontWeight: 'bold' }}>
              {t('forgotPassword.notFoundBold')}
            </p>
            <p style={{ margin: '0 0 15px 0' }}>
              {t('forgotPassword.notFoundCreate')}
            </p>
            <Link
              to="/register"
              className="btn-submit"
              style={{ display: 'inline-block', textAlign: 'center', textDecoration: 'none' }}
            >
              {t('forgotPassword.registerCta')}
            </Link>
          </div>
          <p className="auth-link">
            <Link to="/login">{t('forgotPassword.backLogin')}</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1>{t('forgotPassword.title')}</h1>
        <p style={{ color: 'var(--text-gray)', marginBottom: '1.5rem' }}>
          {t('forgotPassword.intro')}
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">{t('forgotPassword.emailLabel')}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              required
              placeholder="votre@email.com"
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? t('forgotPassword.sending') : t('forgotPassword.submit')}
          </button>
        </form>

        <p className="auth-link">
          <Link to="/login">{t('forgotPassword.backLogin')}</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;

